import firebase from "firebase";
export const getUser = (uid) => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .doc(uid)
    .onSnapshot((doc) => {
      dispatch({
        type: "GET_USER",
        user: { id: doc.id, ...doc.data() },
      });
    });
};
export const getUsers = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .onSnapshot((data) => {
      var users = [];
      data.docs.forEach((doc) => {
        users.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_USERS",
        users,
      });
    });
};
